export default __webpack_public_path__ + "static/media/hotel-icon.e7a4ed3d.svg";